import { Component, input } from '@angular/core';
import { SeverityType } from '../button/button.types';
import { TagModule } from '@openng/optimus-ui/tag';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { IconComponent } from '../icon/icon.component';
import { NgTemplateOutlet } from '@angular/common';
import { MapLinkComponent } from '../../../modules/shared/components/map-link/map-link.component';
import { MapLinkFormatEnum } from '../../../modules/shared/components/map-link/map-link.types';

@Component({
    selector: 'app-map-link-tag',
    templateUrl: 'map-link-tag.component.html',
    styleUrl: 'map-link-tag.component.scss',
    imports: [
        TagModule,
        TooltipModule,
        IconComponent,
        MapLinkComponent,
        NgTemplateOutlet,
    ],
})
export class MapLinkTagComponent {

    protected readonly MapLinkFormatEnum = MapLinkFormatEnum;

    public icon = input<string | null>(null);
    public svgIcon = input<string | null>(null);

    public severity = input<SeverityType>('primary');
    public rounded = input(false);

    public address = input.required<any | null>();
}
